/*
 * Copyright (c) 2024-2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */
import React from 'react'
import clsx from 'clsx'
import UiLanguageSwitcher from './UiLanguageSwitcher'
import logoArbopark from '../../assets/images/logo-arbopark.png'

type UiAuthFormShellProps = {
    title: React.ReactNode
    subtitle?: React.ReactNode
    children: React.ReactNode
    footer?: React.ReactNode
    className?: string
}

const UiAuthFormShell: React.FC<UiAuthFormShellProps> = ({
    title,
    subtitle,
    children,
    footer,
    className,
}) => {
    return (
        <div
            className={clsx(
                'UiAuthFormShell w-full min-h-screen flex items-center justify-center',
                'px-4 py-8',
                'bg-gradient-to-br from-gray-50 to-gray-100 dark:from-gray-900 dark:to-black',
                className
            )}
        >
            <div className={clsx('w-full max-w-md')}>
                <div
                    className={clsx(
                        'bg-white dark:bg-gray-800 rounded-2xl shadow-xl border border-gray-200 dark:border-white/10',
                        'px-8 py-8',
                        'relative'
                    )}
                >
                    <div className="absolute top-5 right-5">
                        <UiLanguageSwitcher />
                    </div>

                    {/* Logo */}
                    <div className={clsx('flex justify-center mb-8')}>
                        <img
                            src={logoArbopark}
                            alt="ArboPark Logo"
                            className={clsx('h-16 w-auto object-contain')}
                        />
                    </div>

                    {/* Title and Subtitle */}
                    <div className={clsx('text-center space-y-2 mb-6')}>
                        <h1
                            className={clsx(
                                'text-2xl font-bold text-gray-900 dark:text-white'
                            )}
                        >
                            {title}
                        </h1>
                        {subtitle && (
                            <p
                                className={clsx(
                                    'text-sm text-gray-600 dark:text-gray-400'
                                )}
                            >
                                {subtitle}
                            </p>
                        )}
                    </div>

                    {/* Form Content */}
                    {children}

                    {/* Footer */}
                    {footer && <div className={clsx('mt-6')}>{footer}</div>}
                </div>
            </div>
        </div>
    )
}

export default UiAuthFormShell
